module.exports = "h1,\nh3, #text {\n  text-align: center;\n}\n\n.centered {\n  display: block;\n  margin: 0 auto;\n}\n\n.logo {\n  max-width: 300px;\n}\n\n.leapest {\n  font-weight: bold;\n  font-size: 110%;\n}\n\n.pdf-icon-wrapper {\n  height: 300px;\n  text-align: center;\n  padding-top: 105px;\n}\n\n.pdf-icon {\n  font-size: 600%;\n  margin-bottom: 20px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/buyer-to-seller-wrapper/leapest-message/leapest-message.component.css
// module id = ./src/app/core/components/buyer-to-seller-wrapper/leapest-message/leapest-message.component.css
// module chunks = main